import { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Chip,
  Pagination,
  useTheme,
  useMediaQuery,
  Card,
  CardContent,
  Divider,
  TextField,
  Button,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Tooltip,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

import {
  Search,
  Sort,
  PlayArrow,
  BarChart,
  Download,
  AccessTime,
  Person,
} from "@mui/icons-material";
import NoData from "../../../components/NoData";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { palette, theme as colorTheme } from "../../../Convoze.theme";
import { jwtDecode } from "jwt-decode";

const primary = colorTheme('palette', 'primary').value;
const pop = colorTheme('palette', 'pop').value;
const positive = colorTheme('palette', 'positive').value;
const neutral = colorTheme('palette', 'neutral').value;
const negative = colorTheme('palette', 'negative').value;



function CallTable({ myCallsData }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const baseUrl = process.env.REACT_APP_NIPPON_CONVOZE_AUDIO_PATH;
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const decodedToken = token ? jwtDecode(token) : "";

  const [audioModalOpen, setAudioModalOpen] = useState(false);
  const [selectedAudioUrl, setSelectedAudioUrl] = useState(null);
  const handlePlayAudio = (audioUrl) => {
    setAudioModalOpen(true);
    setSelectedAudioUrl(audioUrl);
  };

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const filteredData = myCallsData?.filter((record) => {
    const lowerSearch = searchTerm.toLowerCase();
    return (
      (record?.dialerId || "").toLowerCase().includes(lowerSearch) ||
      (record?.overAllSentiment || "").toLowerCase().includes(lowerSearch) ||
      (record?.customerName || "").toLowerCase().includes(lowerSearch)
    );
  });
  const rowsPerPage = 5;
  const totalPages = Math.ceil((filteredData?.length || 0) / rowsPerPage);

  const paginatedData = filteredData?.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );
  const callData = [
    {
      id: "#CR-2356",
      date: "Jun 15, 2023",
      time: "10:23 AM",
      customer: {
        name: "Robert Anderson",
        email: "robert.a@example.com",
      },
      duration: "08:45",
      sentiment: {
        label: "Positive",
        score: 8.7,
        color: "success",
      },
      purpose: "Product Support",
    },
    {
      id: "#CR-2352",
      date: "Jun 14, 2023",
      time: "03:17 PM",
      customer: {
        name: "Jennifer Lopez",
        email: "j.lopez@example.com",
      },
      duration: "12:03",
      sentiment: {
        label: "Neutral",
        score: 6.5,
        color: "warning",
      },
      purpose: "Billing Issue",
    },
    {
      id: "#CR-2349",
      date: "Jun 14, 2023",
      time: "11:42 AM",
      customer: {
        name: "Michael Chen",
        email: "m.chen@example.com",
      },
      duration: "05:30",
      sentiment: {
        label: "Negative",
        score: 4.2,
        color: "error",
      },
      purpose: "Complaint",
    },
    {
      id: "#CR-2346",
      date: "Jun 13, 2023",
      time: "02:35 PM",
      customer: {
        name: "Sarah Williams",
        email: "s.williams@example.com",
      },
      duration: "07:12",
      sentiment: {
        label: "Positive",
        score: 9.1,
        color: "success",
      },
      purpose: "Technical Support",
    },
    {
      id: "#CR-2343",
      date: "Jun 13, 2023",
      time: "10:15 AM",
      customer: {
        name: "David Johnson",
        email: "d.johnson@example.com",
      },
      duration: "06:45",
      sentiment: {
        label: "Positive",
        score: 8.3,
        color: "success",
      },
      purpose: "Inquiry",
    },
  ];

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };

  //   <Box sx={{ display: "flex" }}>
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       style={{ color: "#6366F1" }}
  //       class="h-5 w-5"
  //       fill="none"
  //       viewBox="0 0 24 24"
  //       stroke="currentColor"
  //       width="24"
  //       height="24"
  //     >
  //       <path
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //         stroke-width="2"
  //         d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
  //       ></path>
  //       <path
  //         stroke-linecap="round"
  //         stroke-linejoin="round"
  //         stroke-width="2"
  //         d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  //       ></path>
  //     </svg>
  //     {/* <IconButton size="small" sx={{ color: "#6366F1" }} title="Play Recording">
  //       <PlayArrow />
  //     </IconButton> */}
  //     {/* <IconButton size="small" sx={{ color: "#6366F1" }} title="View Analytics">
  //       <BarChart />
  //     </IconButton>
  //     <IconButton size="small" sx={{ color: "#6366F1" }} title="Download">
  //       <Download />
  //     </IconButton> */}
  //   </Box>
  // );

  // Mobile Card Component
  const MobileCallCard = ({ record }) => (
    <Card sx={{ mb: 2, border: "1px solid #e0e0e0" }}>
      <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            mb: 2,
          }}
        >
          <Box>
            <Typography variant="subtitle2" color="primary" fontWeight="600">
              {record?.dialerId}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {record?.date} • { }
            </Typography>
          </Box>
          <Chip
            label={`${record?.overAllSentiment} (${""})`}
            size="small"
            sx={{
              fontWeight: 500,
              bgcolor:
                record?.overAllSentiment === "Positive"
                  ? positive
                  : record?.overAllSentiment === "Neutral"
                    ? neutral
                    : negative,
              color: "#fff",
            }}
          />
        </Box>

        <Box sx={{ mb: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <Person sx={{ fontSize: 16, mr: 1, color: "text.secondary" }} />
            <Typography variant="body2" fontWeight="500">
              {record?.customerName || "NA"}
            </Typography>
          </Box>
        </Box>

        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item size={{ xs: 6 }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <AccessTime
                sx={{ fontSize: 16, mr: 1, color: "text.secondary" }}
              />
              <Typography variant="body2">
                {record?.callDuration || "NA"}
              </Typography>
            </Box>
          </Grid>
          <Grid item size={{ xs: 6 }}>
            <Typography variant="body2" color="text.secondary">
              {record?.callIntent || "NA"}
            </Typography>
          </Grid>
          <Grid item size={{ xs: 6 }}>
            <Typography variant="body2" color="text.secondary">
              {record?.conversionInsightsOutcome || "NA"}
            </Typography>
          </Grid>
          <Grid item size={{ xs: 6 }}>
            <Typography variant="body2" color="text.secondary">
              {record?.conversionInsightsResponsible || "NA"}
            </Typography>
          </Grid>
        </Grid>

        <Divider sx={{ mb: 2 }} />
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <ActionButtons record={record} />
        </Box>
      </CardContent>
    </Card>
  );

  const ActionButtons = ({ record }) => {
    const hasAudio =
      !!record?.filePath && record.filePath.trim().toUpperCase() !== "N/A";

    return (
      <Box sx={{ display: "flex" }}>
        <Tooltip
          arrow
          title={hasAudio ? "Play Recording" : "No recording available"}
          sx={{
            cursor: "pointer",
          }}
        >
          <span>
            <IconButton
              size="small"
              disabled={!hasAudio}
              onClick={() => hasAudio && handlePlayAudio(record.filePath)}
              sx={{
                color: primary,
                "&.Mui-disabled": {
                  color: (theme) => theme.palette.text.disabled,
                  // cursor: "not-allowed",
                },
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                style={{ color: "inherit" }}
                viewBox="0 0 24 24"
                width="24"
                height="24"
                fill="none"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </IconButton>
          </span>
        </Tooltip>
      </Box>
    );
  };

  return (
    <>
      <Paper
        elevation={0}
        sx={{
          p: 2,
          border: "1px solid #e0e0e0",
          borderRadius: 2,
        }}
      >
        <Box
          sx={{
            mb: 3,
            display: "flex",
            justifyContent: "space-between",
            flexDirection: { xs: "column", md: "row" },
            gap: 1,
          }}
        >
          <Typography
            variant="h6"
            component="h2"
            fontWeight="600"
            color="text.primary"
          >
            Call Recordings
          </Typography>
          <Box
            sx={{ display: "flex", gap: 2, width: isMobile ? "100%" : "auto" }}
          >
            {/* <TextField
              placeholder="Search by Call ID"
              value={searchTerm}
              onChange={handleSearchChange}
              size="small"
              sx={{ minWidth: 250, width: isMobile ? "100%" : "auto" }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search sx={{ color: "text.secondary" }} />
                  </InputAdornment>
                ),
              }}
            />

            <Button
              variant="outlined"
              size="small"
              onClick={() => {
                setSearchTerm("");
                setCurrentPage(1);
              }}
              sx={{
                height: 40,
                borderColor: "rgba(0,0,0,0.23)",
                color: "rgba(0,0,0,0.87)",
                whiteSpace: "nowrap",
                minWidth: "auto",
                px: 1.5,
                fontSize: "0.875rem",
                fontWeight: 500,
                textTransform: "none",
                
              }}
            >
              Clear
            </Button> */}

            <TextField
              placeholder="Search by Call ID"
              value={searchTerm}
              onChange={handleSearchChange}
              size="small"
              sx={{
                minWidth: 250,
                width: isMobile ? "100%" : "auto",
                "& .MuiOutlinedInput-root": {
                  "&.Mui-focused fieldset": { borderColor: primary },
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search sx={{ color: "text.secondary" }} />
                  </InputAdornment>
                ),
              }}
            />

            <Button
              variant="outlined"
              size="small"
              onClick={() => {
                setSearchTerm("");
                setCurrentPage(1);
              }}

              sx={{
                height: 40,
                whiteSpace: "nowrap",
                minWidth: "auto",
                px: 1.5,
                fontSize: "0.875rem",
                fontWeight: 500,
                textTransform: "none",
                cursor: searchTerm ? "pointer" : "default",
                borderColor: searchTerm ? primary : "rgba(0,0,0,0.23)",
                color: searchTerm ? "#fff" : "rgba(0,0,0,0.87)",
                backgroundColor: searchTerm ? primary : "transparent",
                "&:hover": {
                  borderColor: searchTerm ? primary : "rgba(0,0,0,0.23)",
                  backgroundColor: searchTerm ? primary : "transparent",
                },
              }}
            >
              Clear
            </Button>

            {/* <Button
              variant="outlined"
              startIcon={<Sort />}
              sx={{
                borderColor: "#d0d0d0",
                color: "text.primary",
                "&:hover": {
                  borderColor: "#b0b0b0",
                  backgroundColor: "rgba(0, 0, 0, 0.04)",
                },
                minWidth: isMobile ? "auto" : "100px",
              }}
            >
              {!isSmallMobile && "Sort"}
            </Button> */}
          </Box>
        </Box>
        {/* Table for Desktop/Tablet */}
        {!isMobile && (
          <Paper elevation={0} sx={{ borderRadius: 2 }}>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#fafafa" }}>
                    <TableCell
                      sx={{
                        fontWeight: 600,
                        color: "text.secondary",
                        fontSize: "0.75rem",
                      }}
                    >
                      DATE & TIME
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: 600,
                        color: "text.secondary",
                        fontSize: "0.75rem",
                      }}
                    >
                      CALL ID
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: 600,
                        color: "text.secondary",
                        fontSize: "0.75rem",
                      }}
                    >
                      CUSTOMER
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: 600,
                        color: "text.secondary",
                        fontSize: "0.75rem",
                      }}
                    >
                      INTENT
                    </TableCell>
                    {decodedToken?.companyId === "67e560a6ae2e0d3f96b5eb08" && (
                      <>
                        <TableCell
                          sx={{
                            fontWeight: 600,
                            color: "text.secondary",
                            fontSize: "0.75rem",
                          }}
                        >
                          Conversion Status
                        </TableCell>

                        <TableCell
                          sx={{
                            fontWeight: 600,
                            color: "text.secondary",
                            fontSize: "0.75rem",
                          }}
                        >
                          Responsibility
                        </TableCell>
                      </>
                    )}
                    <TableCell
                      sx={{
                        fontWeight: 600,
                        color: "text.secondary",
                        fontSize: "0.75rem",
                      }}
                    >
                      DURATION
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: 600,
                        color: "text.secondary",
                        fontSize: "0.75rem",
                      }}
                    >
                      SENTIMENT
                    </TableCell>

                    <TableCell
                      sx={{
                        fontWeight: 600,
                        color: "text.secondary",
                        fontSize: "0.75rem",
                      }}
                    >
                      ACTIONS
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedData?.length > 0 ? (
                    paginatedData?.map((record, index) => (
                      <TableRow
                        key={index}
                        sx={{ "&:hover": { backgroundColor: "#f9f9f9" } }}
                      >
                        <TableCell>
                          <Box>
                            <Typography variant="body2" color="text.secondary">
                              {moment
                                .utc(record?.callDate)
                                .format("MMM DD, YYYY")}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              {moment.utc(record?.callDate).format("hh:mm A")}
                            </Typography>
                          </Box>
                        </TableCell>
                        {/* 
                            <TableCell
                              onClick={() => {
                                navigate(
                                  `/user/audio-analytics/${record?.transcriptionId}`
                                );
                              }}
                              sx={{ cursor: "pointer" }}
                            >
                              <Typography
                                variant="body2"
                                color="#6366F1"
                                fontWeight="500"
                              >
                                {record?.dialerId
                                  ? `#${record?.dialerId}`
                                  : "NA"}{" "}
                              </Typography>
                            
                            </TableCell> */}

                        <TableCell
                          onClick={() => {
                            if (
                              !!record?.filePath &&
                              record.filePath.trim().toUpperCase() !== "N/A"
                            ) {
                              navigate(
                                `/user/audio-analytics/${record?.transcriptionId}`
                              );
                            }
                          }}
                          sx={{
                            cursor:
                              !!record?.filePath &&
                                record.filePath.trim().toUpperCase() !== "N/A"
                                ? "pointer"
                                : "default",
                          }}
                        >
                          <Typography
                            variant="body2"
                            color={
                              !!record?.filePath &&
                                record.filePath.trim().toUpperCase() !== "N/A"
                                ? primary
                                : "grey"
                            }
                            fontWeight="500"
                          >
                            {record?.dialerId ? `#${record?.dialerId}` : "NA"}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Box>
                            <Typography variant="body2" fontWeight="500">
                              {record?.customerName || "NA"}
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" color="text.secondary">
                            {record?.subDisposition
                              ? record?.subDisposition
                              : record?.callIntent || "NA"}
                          </Typography>
                        </TableCell>
                        {decodedToken?.companyId === "67e560a6ae2e0d3f96b5eb08" && (
                          <>
                            <TableCell>
                              <Typography variant="body2">
                                {record?.conversionInsightsOutcome || "NA"}
                              </Typography>
                            </TableCell>

                            <TableCell>
                              <Typography variant="body2">
                                {record?.conversionInsightsResponsible || "NA"}
                              </Typography>
                            </TableCell>
                          </>
                        )}
                        <TableCell>
                          <Typography variant="body2">
                            {record?.callDuration || "NA"}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={`${record?.overAllSentiment || "NA"} `}
                            size="small"
                            sx={{
                              fontWeight: 500,
                              bgcolor:
                                record?.overAllSentiment === "Positive"
                                  ? positive
                                  : record?.overAllSentiment === "Neutral"
                                    ? neutral
                                    : negative,
                              color: "#fff",
                            }}
                          />
                        </TableCell>

                        <TableCell>
                          <ActionButtons record={record} />
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        <NoData />
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        )}

        {/* Mobile Cards */}
        {isMobile && (
          <Box>
            {myCallsData?.map((record, index) => (
              <MobileCallCard key={index} record={record} />
            ))}
          </Box>
        )}

        {/* Audio Modal */}
        <Dialog
          open={audioModalOpen}
          onClose={() => setAudioModalOpen(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Call Recording</DialogTitle>
          <DialogContent>
            {selectedAudioUrl ? (
              <audio controls autoPlay style={{ width: "100%" }}>
                <source
                  src={`${baseUrl}/${selectedAudioUrl}`}
                  type="audio/mpeg"
                />
                Your browser does not support the audio element.
              </audio>
            ) : (
              <Typography>No audio available</Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setAudioModalOpen(false)} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* Footer */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: 3,
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? 2 : 0,
            p: 1,
          }}
        >
          <Typography variant="body2" color={primary} fontWeight={600}>
            Showing {(currentPage - 1) * rowsPerPage + 1} to{" "}
            {Math.min(currentPage * rowsPerPage, filteredData?.length || 0)} of{" "}
            {filteredData?.length || 0} results
          </Typography>

          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={handlePageChange}
            showFirstButton
            showLastButton
            siblingCount={isMobile ? 0 : 1}
            boundaryCount={isMobile ? 1 : 2}
            sx={{
              color: primary,
              "& .MuiPaginationItem-root": {
                color: primary,
              },
              "& .MuiPaginationItem-root.Mui-selected": {
                backgroundColor: primary,
                color: "#fff",
                borderColor: primary,
                "&:hover": {
                  backgroundColor: primary,
                },
              },
            }}
          />
        </Box>
      </Paper >
    </>
  );
}

export default CallTable;
